// Constants
import WorkspaceMeetingsConstants from '../constants/WorkspaceMeetings.constants';

// utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Schema
import WorkspaceMeetingsSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceMeeting.schema';
import WorkspaceAgendaSnapshotSchema from 'Shared/utils/normalizeJSON/schemas/WorkspaceAgendaSnapshot.schema';

// API
import * as WorkspaceMeetingsAPI from '../api/WorkspaceMeetings.api';

// Helpers
import { showNotificationError } from 'Shared/helpers';

export const fetchWorkspaceMeetingsSuccess = payload => ({
  type: WorkspaceMeetingsConstants.Actions.FETCH_WORKSPACE_MEETINGS_SUCCESS,
  payload,
});

export const fetchWorkspaceMeetingSnapshotSuccess = payload => ({
  type: WorkspaceMeetingsConstants.Actions.FETCH_WORKSPACE_MEETING_SNAPSHOT_SUCCESS,
  payload,
});

export const fetchWorkspaceMeetings = ({
  workspaceId,
  params,
}: {
  workspaceId: string;
  params?: { view?: 'day' | 'week' | 'month'; date?: string; include_snapshots?: boolean };
}) => dispatch => {
  return WorkspaceMeetingsAPI.fetchWorkspaceMeetings(workspaceId, params)
    .then(response => {
      const responseData = normalizer(WorkspaceMeetingsSchema, response.data.workspace_meetings);
      dispatch(fetchWorkspaceMeetingsSuccess(responseData));
      return responseData;
    })
    .catch(error => {
      showNotificationError(error);
    });
};

export const fetchWorkspaceMeetingSnapshot = ({
  workspaceId,
  snapshotUuid,
}: {
  workspaceId: string;
  snapshotUuid: string;
}) => dispatch => {
  return WorkspaceMeetingsAPI.fetchWorkspaceMeetingSnapshot(workspaceId, snapshotUuid)
    .then(response => {
      const responseData = normalizer(WorkspaceAgendaSnapshotSchema, response.data.workspace_agenda_snapshot);
      dispatch(fetchWorkspaceMeetingSnapshotSuccess(responseData));
      return responseData;
    })
    .catch(error => {
      showNotificationError(error);
    });
};
